import React from 'react';
import { RadioGroup } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

const generationTypes = [
  { id: 'Normal', title: 'Standard', description: 'High fidelity textured model' },
  { id: 'LowPoly', title: 'Low Poly', description: 'Optimized geometry with smart reduction' },
  { id: 'Sketch', title: 'Sketch to 3D', description: 'Generate from line art or sketches' },
  { id: 'Geometry', title: 'Geometry Only', description: 'Untextured white model' },
];

export default function GenerationTypeSelector({ selectedType, setSelectedType }) {
  return (
    <div className="w-full mt-4">
      <div className="flex items-center justify-between mb-2">
        <label className="text-[10px] font-mono uppercase text-muted-foreground tracking-widest">
          Generation Style
        </label>
      </div>
      <RadioGroup value={selectedType} onChange={setSelectedType}>
        <div className="grid grid-cols-1 gap-y-2 sm:grid-cols-2 sm:gap-x-4">
          {generationTypes.map((type) => (
            <RadioGroup.Option
              key={type.id}
              value={type.id}
              className={({ active, checked }) =>
                `relative flex cursor-pointer rounded-xl border p-3 shadow-sm focus:outline-none transition-all duration-200
                ${checked ? 'bg-indigo-500/10 border-indigo-500/50 ring-1 ring-indigo-500' : 'bg-black/5 dark:bg-white/5 border-border/50 hover:border-indigo-500/30'}
                `
              }
            >
              {({ checked, active }) => (
                <>
                  <div className="flex flex-1">
                    <div className="flex flex-col">
                      <RadioGroup.Label as="span" className={`block text-xs font-bold uppercase tracking-wider ${checked ? 'text-indigo-500' : 'text-foreground'}`}>
                        {type.title}
                      </RadioGroup.Label>
                      <RadioGroup.Description as="span" className={`mt-1 flex items-center text-[10px] ${checked ? 'text-indigo-500/80' : 'text-muted-foreground'}`}>
                        {type.description}
                      </RadioGroup.Description>
                    </div>
                  </div>
                  {checked && (
                    <CheckCircleIcon className="h-5 w-5 text-indigo-500" aria-hidden="true" />
                  )}
                </>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
